export default "__VITE_ASSET__IKyeJQKs__"